<template>
  <!--二维码-->
  <div>
    <div class="qr qrup">
      <div class="title">Service Hotline</div>
      <div class="tel">
        <i class="fa fa-skype" aria-hidden="true"></i>
        <span>{{homePage.skype}}</span>
      </div>
      <div class="tel">
        <i class="fa fa-whatsapp" aria-hidden="true"></i>
        <span>{{homePage.whatsapp}}</span>
      </div>
      <div class="tel">
        <i class="fa fa-phone"
           aria-hidden="true"></i>
        <span>{{homePage.phone}}</span>
      </div>
      <div class="tel" @click="openQQ()">
        <i class="fa fa-qq"
           aria-hidden="true"></i>
        <span>{{homePage.qqNumber}}</span>
      </div>
      <div class="qrimg">
        <img class="img-path" @mouseover="dialogVisible = true" :src="homePage.wechatCode" />
      </div>
    </div>
    <!--二维码弹出-->
    <el-dialog :visible.sync="dialogVisible"
               @close="dialogVisible=false"
               :before-close="closeDia"
               :lock-scroll="false"
               class="qrImg-dialog"
               width="30%">
      <img class="qrImg"
           :src="homePage.wechatCode" />

    </el-dialog>
  </div>
</template>
<script>
import { getHomePage } from '../api/api'
export default {
  data () {
    return {
      dialogVisible: false,
      top: false,
      homePage:{}
    }
  },
  methods: {
    //查看二维码
    over () {
      this.dialogVisible = true;
    },
    closeDia () {
      this.dialogVisible = false;
    },
    //监听页面高度
    showIcon () {
      if (document.documentElement.scrollTop >= 300) {
        this.top = true
      } else {
        this.top = false
      }
    },
    openQQ(){
      window.open('http://wpa.qq.com/msgrd?v=3&uin='+this.homePage.qqNumber+'&site=qq&menu=yes','_brank');
    },
    getHomePage() {
      var that = this;
      getHomePage().then(res => {
        that.homePage = res.data;
      });
    }
  },
  mounted () {
    this.getHomePage();
    //添加页面监听事件
    window.addEventListener("scroll", this.showIcon);
  }
}
</script>
<style lang="scss">
.qrImg-dialog{
  .el-dialog__body {
    padding: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      height: 350px;
    }
  }

  .el-dialog {
    width: 300px !important;
  }

  .el-dialog__header {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qr.vue